import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-698fa35a")

_pushScopeId("data-v-698fa35a")
const _hoisted_1 = {
  key: 0,
  class: "videoNode"
}
const _hoisted_2 = { class: "knowledgePoints" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "知识点", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VideoOutline = _resolveComponent("VideoOutline")

  return (_openBlock(), _createBlock("div", {
    class: "base-element-image",
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
      transform: `rotate(${_ctx.elementInfo.rotate}deg)`,
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _createVNode("div", {
        class: "element-content",
        style: {
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        }
      }, [
        _createVNode(_component_VideoOutline, { elementInfo: _ctx.elementInfo }, null, 8, ["elementInfo"]),
        _createVNode("div", {
          class: "image-content audienceVideo",
          style: { clipPath: _ctx.clipShape.style }
        }, [
          _createVNode("video", {
            id: 'video' + _ctx.elementInfo.id,
            class: "video-js vjs-big-play-centered",
            style: {
              top: _ctx.imgPosition.top,
              left: _ctx.imgPosition.left,
              width: _ctx.imgPosition.width,
              height: _ctx.imgPosition.height,
            },
            muted: ""
          }, [
            _createVNode("source", {
              src: _ctx.elementInfo.src,
              type: "video/mp4"
            }, null, 8, ["src"])
          ], 12, ["id"])
        ], 4)
      ], 4),
      (_ctx.elementInfo.videoSource && _ctx.elementInfo.marker.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode("div", {
                innerHTML: _ctx.elementInfo.actionPointKnowledges && _ctx.elementInfo.actionPointKnowledges.length > 0 ? _ctx.elementInfo.actionPointKnowledges[_ctx.pointIndex] : ''
              }, null, 8, ["innerHTML"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
})